import React, { useEffect, useMemo } from 'react';
import M_PER_NEW_03 from './M_PER_NEW_03';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import { useSelector, useDispatch } from 'react-redux';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useParams, useLocation } from 'react-router-dom';
import { useSearch1, useSave1 } from './M_PER_NEW_03_Query';
import { useSave } from '../../../../Hooks/useSave';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import useFcmHandler from '../../../../Hooks/useFcmHandler';

export default function M_PER_NEW_03F() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { baseInfo } = useSelector((state) => state.permit);
  const sendFcm = useFcmHandler();
  const dispatch = useDispatch();
  const { id: dailyCdFromRoute } = useParams();
  const location = useLocation();
  const { navigate } = useAppNavigate();

  const searchDailyCd = String(
    dailyCdFromRoute || location.state?.dailyCd || ''
  );

  const { run: Search1 } = useSearch1({
    onSuccess: (response) => {
      const resData = Array.isArray(response) ? response[0] : response;
      if (!resData?.dailies?.length) return;

      const daily =
        resData.dailies.find(
          (item) =>
            searchDailyCd && String(item.dailyCd) === String(searchDailyCd)
        ) || resData.dailies[0];
      const details = daily.details || [];
      const currentDailyCd = String(daily.dailyCd ?? '');
      const currentWorkDate = daily.workDate?.split(' ')[0] || '';

      const risks = [];
      const equips = [];
      const preps = [];
      const selectedWorkItemIds = [];

      details.forEach((detail) => {
        const wId = String(detail.workItemId);
        selectedWorkItemIds.push(wId);

        detail.riskItems?.forEach((r) => {
          if (r.itemCheck === '1')
            risks.push({ ...r, workItemId: wId, itemCheck: 'Y' });
        });
        detail.equipItems?.forEach((e) => {
          if (e.itemCheck === '1')
            equips.push({ ...e, workItemId: wId, itemCheck: 'Y' });
        });
        detail.prepItems?.forEach((p) => {
          if (p.itemCheck === '1')
            preps.push({ ...p, workItemId: wId, itemCheck: 'Y' });
        });
      });

      dispatch(
        PermitActions.setCodeInfo({ risks, equips, preparations: preps })
      );
      dispatch(
        PermitActions.setBaseInfo({
          ...resData,
          dailies: [daily],
          pmCd: resData.mst?.pmCd ?? resData.pmCd ?? '',
          currentDailyCd,
          currentWorkDate,
          workItemIds: selectedWorkItemIds,
          workStartDt: currentWorkDate,
        })
      );
    },
  });

  useEffect(() => {
    if (!searchDailyCd) return;
    Search1({ dailyCd: searchDailyCd });
  }, [searchDailyCd]);

  const { mutateAsync: save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_PER_NEW_03',
    schema: null,

    saveData: (params) => ({ ...params }),

    requestSave: async (requestRows) => {
      return await save1Async(requestRows[0]);
    },

    showSuccess: false,

    onSuccess: async () => {
      const dailyCd = String(
        baseInfo.currentDailyCd ?? baseInfo.dailies?.[0]?.dailyCd ?? searchDailyCd
      );

      dispatch(
        showSnackbar({
          message: '연장 신청이 완료되었습니다.',
          type: 'success',
        })
      );
      dispatch(CommonActions.setActiveStep(0));
      await sendFcm({
        targetUserId: baseInfo.mst.smId,
        requestUserId: userInfo.userid,
        body: '작업 허가서 연장 요청입니다.',
        status: '연장요청',
        codeGroup: 'AL_002_001',
        title: '작업허가서 연장',
        route: '/M_Permit',
        responseData: dailyCd,
      });
      // 입회자는 선택사항 — 지정하지 않았으면 입회자 알림을 보내지 않음
      if (baseInfo.mst.assignWitnessId) {
        await sendFcm({
          targetUserId: baseInfo.mst.assignWitnessId,
          requestUserId: userInfo.userid,
          body: '작업 허가서 연장 요청되었습니다.',
          status: '연장요청',
          codeGroup: 'AL_002_001',
          title: '작업허가서 연장',
          route: '/M_Permit',
          responseData: dailyCd,
        });
      }
      navigate('/M_Permit');
    },
  });

  const permitData = useMemo(() => {
    const details = baseInfo?.dailies?.[0]?.details ?? [];
    const workTypes = details.map((d) => ({
      id: d.dtlCd,
      label: d.workTypeNm,
      endTime: d.endTime,
    }));

    const currentEndTime =
      workTypes.length > 0
        ? workTypes.reduce(
            (latest, w) => (w.endTime > latest ? w.endTime : latest),
            workTypes[0].endTime
          )
        : '00:00';

    return { workTypes, currentEndTime };
  }, [baseInfo]);

  const handleSubmit = ({ dtlCds, extEndTime }) => {
    Save1({ userInfo, dtlCds, extEndTime });
  };

  return (
    <div className="wrap">
      <M_PER_NEW_03 permitData={permitData} onSubmit={handleSubmit} />
    </div>
  );
}
